import { useEffect, useState } from "react";
import { Typography, Space, Avatar, Table, Tag} from "antd";
import { Link, useNavigate } from "react-router-dom";
import { LinkedinOutlined, MediumOutlined} from '@ant-design/icons';
import {Footer, Container, MenuSmall} from '../auxiliary/auxiliary';


export default function BugbountyTable(props) {
  const navigate = useNavigate();



//   const data = [
//     {
//       "key": "1",
//       "logo": "tkey_logo.jpeg",
//       "name": "TKey",
//       "open_source": true,
//       "сurrency": "€",
//       "min": 100, 
//       "max": 10000,
//       "short": "Tillitis develops the TKey, an open and secure hardware device designed to protect secrets like private keys through transparency and strong security principles, supported by a bug bounty program to ensure ongoing resilience.",
//       "tags": ["Open source", "Hardware"]
//     }
// ];


  return ( 
    <>
  
    <Table  style={{ width: "100%" }} dataSource={props.data}
  
    onRow={(record) => {
      return {
        onClick: () => {
          // переход по ссылке
         // window.location.href = `/bugbounty/?id=${record.key}`;
         
          // props.setSelectedProgram(record);
          navigate(`/bugbounty/${record.key}/`, { replace: true });
          
          
        },
        style: { cursor: "pointer", backgroundColor: record.status ? "#f5f5f5" : "transparent", }
      };
    }}
    
    >
      <Table.ColumnGroup title="Program Name">
        <Table.Column  title="Logo" dataIndex="logo" key="logo"  render={(logo) => (
        <Avatar
          shape="square"
          size={48}  
          src={"/logo/"+logo}
        />
      )}
    />
        <Table.Column title="Name" dataIndex="name" key="name" />
      </Table.ColumnGroup>
      
      
      {/* Обновленная колонка Short Description */}
      <Table.Column 
        responsive={['md']} 
        title="Short Description" 
        dataIndex="short" 
        key="short" 
        render={(text, record) => {
          // Если есть статус, возвращаем кастомный текст
          if (record.status) {
            return (
              <span style={{ color: "#d9363e", fontWeight: "bold" }}>
                Suspended
              </span>
            );
          }
          // Иначе возвращаем обычный текст
          return text;
        }}
      />


      <Table.ColumnGroup title="Bounty">
      <Table.Column
        title="Min"
        dataIndex="min"
        key="min"
        render={(min, record) => (
          <span style={{ whiteSpace: 'nowrap' }}>
            {min} {record.сurrency}
          </span>
        )}
      />
       <Table.Column
        title="Max"
        dataIndex="max"
        key="max"
        render={(max, record) => (
          <span style={{ whiteSpace: 'nowrap' }}>
            {max} {record.сurrency}
          </span>
        )}
      />
      {/* <Table.Column title="Currency" dataIndex="сurrency" key="сurrency" /> */}
      </Table.ColumnGroup>
      <Table.Column
        responsive={['md']}
        title="Tags"
        dataIndex="tags"
        key="tags"
        render={tags => (
          <>
            {tags.map(tag => {
              let color = tag.length > 5 ? 'geekblue' : 'green';
              if (tag === 'loser') {
                color = 'volcano';
              }
              return (
                <Tag color={color} key={tag}>
                  {tag.toUpperCase()}
                </Tag>
              );
            })}
          </>
        )}
      />
     
    </Table>
  </>
  );
}


